export default "__VITE_ASSET__ed611c56__"